"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GISService = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _models = require("../models");
var _app = require("./app");
var _http = require("./http");
var _user = require("./user");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class GISService {
  static async sendFile({
    partnerCode,
    ...props
  }) {
    try {
      const formData = new FormData();
      Object.keys(props).forEach(key => {
        const value = props[key];
        if (value) formData.append(key, typeof value === 'number' ? `${value}` : value);
      });
      const data = await _http.HttpService.post('v1', '/sig_files', [], [], formData, {
        partner: partnerCode
      });
      return parseGisFileData(data);
    } catch (err) {
      console.error('[GISService][sendFile]', err);
      throw err;
    }
  }
  static async updateFile(fileId, {
    partnerCode,
    status
  }) {
    try {
      const params = {};
      if (status) params.status = backendStatuses[status];
      const data = await _http.HttpService.patch('v1', `/sig_files/${fileId}`, [], [], JSON.stringify(params), {
        partner: partnerCode
      });
      return parseGisFileData(data);
    } catch (err) {
      console.error('[GISService][updateFile]', err);
      throw err;
    }
  }
  static async getFiles({
    partnerCode,
    fileType
  } = {}) {
    try {
      const params = [];
      if (fileType) params.push({
        key: 'file_type',
        value: fileType
      });
      const data = await _http.HttpService.get('v1', '/sig_files', params, [], null, partnerCode ? {
        partner: partnerCode
      } : {});
      return data.map(parseGisFileData);
    } catch (err) {
      console.error('[GISService][getFiles]', err);
      throw err;
    }
  }
  static async getAnalysis({
    partnerCode,
    ordering,
    page,
    pageSize
  }) {
    try {
      const {
        count,
        results
      } = await _http.HttpService.get('v1', '/geodata_analysis', [{
        key: 'ordering',
        value: ordering
      }, {
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }], [], null, partnerCode ? {
        partner: partnerCode
      } : {});
      return {
        count,
        analysis: results.map(parseGeodataAnalysis)
      };
    } catch (err) {
      console.error('[GISService][getAnalysis]', err);
      throw err;
    }
  }
  static async getFileMessages({
    fileId,
    query
  }) {
    try {
      const res = await _http.HttpService.get('v1', `/sig_files/${fileId}/messages`, [{
        key: 'query',
        value: query
      }, {
        key: 'ordering',
        value: 'id'
      }]);
      return res.map(data => parseGisFileMessageData(data, _app.AppService.environment.backendUrl));
    } catch (err) {
      console.error('[GISService][getFileMessages]', err);
      throw err;
    }
  }
  static async sendMessage({
    fileId,
    message,
    document
  }) {
    try {
      if (!_user.UserService.currentUser) throw new Error('user not connected');
      const formData = new FormData();
      if (document) formData.append('document', document);
      formData.append('data', JSON.stringify({
        message
      }));
      const data = await _http.HttpService.post('v1', `/sig_files/${fileId}/messages`, [], [], formData);
      return parseGisFileMessageData({
        ...data,
        creator: _user.UserService.currentUser,
        created: (0, _moment.default)().toISOString()
      }, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GISService][sendMessage]', err);
      throw err;
    }
  }
}
exports.GISService = GISService;
const statuses = {
  TO_DO: 'toDo',
  DOING: 'doing',
  STAND_BY: 'standby',
  DONE: 'done'
};
const backendStatuses = {
  toDo: 'TO_DO',
  doing: 'DOING',
  standby: 'STAND_BY',
  done: 'DONE'
};
function parseGisFileData({
  id,
  title,
  comment,
  document,
  status,
  created,
  creator,
  messages,
  type,
  geodata_analysis
}) {
  return new _models.GISFile(id, title, comment, document, statuses[status], (0, _moment.default)(created), creator, messages || [], type, geodata_analysis ? parseGeodataAnalysis(geodata_analysis) : null);
}
function parseGisFileMessageData({
  created,
  creator,
  message,
  attachment
}, backendUrl) {
  return new _models.GISFileMessage((0, _moment.default)(created), creator, message, attachment ? `${backendUrl}${attachment}` : null);
}
function parseGeodataAnalysis({
  id,
  title,
  description,
  status,
  created,
  updated
}) {
  return new _models.GeodataAnalysis(id, title || '', description || '', status, (0, _moment.default)(created), (0, _moment.default)(updated));
}